import {
  SELECTABLE_ACCESS_LEVELS,
  accessLevelsWithPrefix,
  NO_OVERRIDE_OPTION,
  PUBLIC_ACCESS_OPTION,
  publicAccessDisplay
} from '../helper/lead_access_levels';
import { faThumbtack } from '@fortawesome/pro-solid-svg-icons';
import { post, patch } from 'helpers/api';

export const RADIO_OPTIONS = {
  NEW_PERSON: 'new_person',
  NEW_COMPANY: 'new_company',
  SEARCH_CONTACTS: 'search_contacts'
};
export const PHONE_OPTIONS = ['Mobile', 'Work'];

export const CONTACTS_PERSON = 'Contacts::Person';
export const CONTACTS_COMPANY = 'Contacts::Company';

export function getStartingStatus(statusId, leadStatuses) {
  if (!statusId) return leadStatuses[0];

  return leadStatuses.find(leadStatus => leadStatus.id === statusId);
}

export function parseContactData(contact) {
  if (contact.person) {
    return {
      associatedModelId: contact.person.id,
      associatedModelType: contact.person.contactType,
      newContact: true
    };
  } else if (contact.company) {
    return {
      associatedModelId: contact.company.id,
      associatedModelType: contact.company.contactType,
      newContact: true
    };
  }
}

const startingVaultGatesOption = { value: NO_OVERRIDE_OPTION, label: 'Do not Pin' };

export const gatherDocAccessLevels = (useVaultGates) => {
  if (useVaultGates) {
    return [startingVaultGatesOption, ...accessLevelsWithPrefix(faThumbtack, 'Pin to ')];
  }

  return [...SELECTABLE_ACCESS_LEVELS, { value: PUBLIC_ACCESS_OPTION, label: publicAccessDisplay }];
};

export function startingAccessLevel(useVaultGates) {
  if (useVaultGates) return startingVaultGatesOption;

  return SELECTABLE_ACCESS_LEVELS.find(accessLevel => accessLevel.value === 'low');
}

export const contactSaveData = (radioSelected, person, projectId, savedContactData, company, persistAddress) => {
  if (radioSelected === RADIO_OPTIONS.NEW_PERSON) {
    const personData = {
      company_name: person.companyName,
      email: person.email,
      first_name: person.firstName,
      last_name: person.lastName,
      job_title: person.jobTitle,
      project_id: projectId,
      phone_numbers_attributes: person.phoneNumbers.filter(phoneNumber => phoneNumber.number !== '')
    };

    const urlAndMethod = { url: '/contacts/people', methodType: post };
    if (savedContactData.current?.associatedModelType === CONTACTS_PERSON) {
      urlAndMethod.url = `/contacts/people/${savedContactData.current.associatedModelId}`;
      urlAndMethod.methodType = patch;
    }

    return { ...urlAndMethod, data: { contacts_person: personData } };
  } else if (radioSelected === RADIO_OPTIONS.NEW_COMPANY) {
    const companyData = {
      name: company.name,
      email: company.email,
      phone_number: company.phoneNumber,
      project_id: projectId
    };

    if (persistAddress) companyData.addressesAttributes = [company.address];

    const urlAndMethod = { url: '/contacts/companies', methodType: post };
    if (savedContactData.current?.associatedModelType === CONTACTS_COMPANY) {
      urlAndMethod.url = `/contacts/companies/${savedContactData.current.associatedModelId}`;
      urlAndMethod.methodType = patch;
    }

    return { ...urlAndMethod, data: { contacts_company: companyData } };
  }
};
